import * as React from 'react'
import { PublicLocale, Widget, WidgetCardType as WidgetCardEnum, WidgetCard as WidgetCardType } from '../../../types'
import Card from './Card'
import HelpCenter from './Cards/HelpCenter'
import NewConversation from './Cards/NewConversation'
import ExternalLink from './Cards/ExternalLink'
import News from './Cards/News'
import Post from './Cards/Post'

interface IProps {
  card: WidgetCardType
  locale: PublicLocale
  widget: Widget
  admin?: boolean
}

const WidgetCard = (props: IProps) => {
  const { widget, locale, card, admin } = props

  switch (card.type) {
    case WidgetCardEnum.NEW_CONVERSATION:
      return (
        <NewConversation
          widget={widget}
          locale={locale}
          card={card}
        />
      )
    case WidgetCardEnum.HELP_CENTER:
      return (
        <HelpCenter
          widget={widget}
          locale={locale}
          card={card}
          admin={admin}
        />
      )
    case WidgetCardEnum.EXTERNAL_LINK:
      return (
        <ExternalLink
          widget={widget}
          locale={locale}
          card={card}
        />
      )
    case WidgetCardEnum.NEWS:
      return (
        <News
          widget={widget}
          locale={locale}
          card={card}
          admin={admin}
        />
      )
    case WidgetCardEnum.POST:
      return (
        <Post
          widget={widget}
          locale={locale}
          card={card}
        />
      )
    default:
      throw new Error(`Unknown widget card type`)
  }
}

export default WidgetCard